module.exports = __webpack_public_path__ + "img/brand.dec28387.png";